module.exports = __webpack_public_path__ + "images/play.f40606b6.png";